import { BuyNowPayLaterConfig } from "~features/checkout/common/checkout.types";
import { FeeType } from "~graphql/sdk";

export type OmitTypename<T> = Omit<T, "__typename">;

export type Reconstruct<T> = {
  [K in keyof T]: T[K];
  // eslint-disable-next-line @typescript-eslint/ban-types
} & {};

type optionsConfig = {
  fee?: number | null;
  type?: FeeType | null;
  showHiddenFees?: boolean;
};

export const calculateBNPLPrice = (
  total: number,
  config: BuyNowPayLaterConfig,
  options: optionsConfig = {}
): number => {
  let fee = 0;

  if (options.showHiddenFees && options.fee) {
    if (options.type === FeeType.Percentage) {
      fee = total * (options.fee / 100);
    } else {
      fee = options.fee;
    }
  }

  return (total + fee) / config.terms;
};

export const isChilliPeppersGAToSeatedHack = (eventId: string): boolean => {
  if (!eventId) return false;

  // https://app.shortcut.com/flicket-ltd/story/6514/chill-peppers-hack
  // https://flicket-workspace.slack.com/archives/C08HLN94N3B/p1759263106553739
  return [
    // 2025 events
    "9451b8e2-fb7d-4a2e-b664-068829ee2858",
    "5e8750f1-e6ae-4aea-a2f3-1f0976b154aa",
    "9d0cf588-0963-49a4-8faf-d7305a0b2f12",
    "4c512782-d80a-4179-8af1-1504e5cce788",
    "3860c583-0fcd-4acd-bceb-9361651bbfc6",
    "ed98487b-7349-4549-9626-2fba3d8f7584",
    "b497724d-4022-4fae-aaa0-d33e1506c8ad",
    "38109049-ada7-4558-be6a-94af38c6fad6",
    "4b5bb399-ad52-477b-bd64-cf1889df7cd6",
    "1bc30cd4-bdf6-4ad1-b341-45f70a36ae4a",
    "7468aafb-be55-4a66-870e-62bd7fb04785",
    "3aa28d92-fa97-47cf-81fd-343d90ff65c1",
    "4fce3d91-a2a5-4553-af70-03b6ee3be936",

    // 2026 events
    "88668db1-fe14-4c5d-8aa3-eba48fc5a69d",
    "b94195c4-4486-4b39-9279-26bf74d2c6a0",
    "3e083e76-ff25-4a0a-b462-bd529051f459",
    "d5710ee8-1af5-4376-9868-9822671fccf8",
    "5c69555d-42a1-4664-8feb-f0f954a75272",
    "db025a00-2e2b-42ac-a497-a1acd85f8ae6",
    "86149735-24cc-44f6-9734-3244fecc3747",
    "95c269b0-dc67-426e-9ec3-8c375d63a10f",
    "58c37200-f4b4-427e-85b1-005fd751693c",
    "b2aba192-12f7-4335-8fde-d86027188cab",
    "370f0d4c-bd6d-427f-a4d2-dc1f26778c9d",
    "eff6e1fa-9761-4887-90d4-82d37ad4350d",
    "62d5915b-79bc-4059-985e-421b6272e332",
    "a6a77108-5581-4fd7-8ccb-304fc05d5fcf",
    "a6157097-ad2a-46b7-ad4a-a54942431bdf",
    "139dff1a-92c9-4879-858f-f597b6eb61fe",
    "552adc3f-1f3a-4027-bb51-0ce0d98c65fe",
    "2948c3c6-c2d5-472a-a299-4a1623da333a",
    "292fdd39-ffbc-4ffd-a6e7-2e15c6897532",
    "0f99f2ec-0309-4d7d-a2ce-2773c3214afb",
    "80139ef2-55dc-4cde-aea6-8d2395af356d",
    "3eddbb64-01d4-4ddb-a7af-e3a7ae7c2f99",
    "151317e2-b66b-4970-9d1e-43a6bdcab0c5",
    "241f3e86-9555-4d29-b4dd-8a8c04f54d5c",
    "a7effd80-bf84-437c-94df-f5f10b355731",
    "067165a4-9415-4da0-bc3b-8e8aed24189b",
    "9b8c9aa1-fcd3-47d2-b258-2582924b6b8e",
    "c8daf813-6f9b-4a35-8e31-2fcef694045c",
    "cd79836d-06f9-4ed3-8e19-16643e41f34c",
    "910fad54-7abf-4d3e-ba10-15ebef9b7280",
    "4cffc45e-e6d3-412c-ac16-ab58d0ff1c47",
    "abc4f8d4-e0c6-4c54-ad93-dbb56d74c078",
    "eaf92269-3d71-47be-9f7d-a87cb161e66e",
    "878a9175-4477-4c66-a391-d7292ea906a9",
    "c2d0ce59-b210-4996-996e-e5ffaa914e6c",
    "e3f63b71-638f-440a-8c8f-945edeb5dcfe",
    "b8c1e6f6-fb3d-45f9-8e06-5b1dfedd5a43",
    "960eee17-35b5-4b93-8a6e-082206a0e125",
    "8382b64c-af40-4fd1-8116-ba826e6e27c6",
    "f642029b-b5d3-47f0-99b3-83f9069a6450",
    "f7687792-d171-4d2d-bb92-479a0389693a",
    "b0375aa5-b2df-43aa-b522-e00d9f3edf0c",
    "32b358d7-c889-461c-a042-afaf39432f72",
    "fb5eeae5-1fb4-48f5-8282-6c6536bb7758",
    "8cfb9ba3-f0f0-48d8-8194-aba45590da5a",
    "c00a6e2d-d3af-4c69-b64c-7707d1d85391",
    "c4723b07-261d-4233-9cc0-ee38132a4026",
    "474772c4-4778-4696-81c7-11a438f9138c",
    "96849b20-58ce-4679-91e0-a60fd13bc6bd",
    "638f7c55-15de-491c-a645-c882462926e8",
    "a8f31a2a-d093-4c59-8e97-12c72ca65548",
    "7ce9bf12-fa39-41f6-8e61-9318ff5862db",
    "a891043b-761b-47f0-9c8c-ad9e713c7f20",
    "a9257366-1ad0-44de-bd5c-a947ebb61511",
    "6aff267b-e847-4602-99af-4f89623268e4",
    "a0a5277c-c2c5-4404-9a7a-42fcd4674880",
    "0efbece1-0f3a-4d59-9631-ecefbc1ff347",
    "557e239f-5bab-465d-9618-c5bc503f1a64",
    "74fd227a-824e-4d63-850c-8067f256a673",
    "2a86921a-fa44-46b6-802c-abf59e1980c9",
    "9fae9176-d122-48fe-8ac4-47a342faaa1f",
    "cf91d3d3-7708-42a3-b78b-7b1dd66bafb0",
    "ec066729-ceeb-445e-b955-eb59c97187fa",
    "d07f8265-df10-49b8-8d02-5ec8264ceaca",
    "48da3d86-3328-49e2-9944-4abcfd248b2d",
    "2ac4ec41-3650-4953-acf0-d0900140ca6a",
    "a6023482-065d-4eac-8c83-f731adc44ce2",
    "2c167fa9-daf6-4155-a3bf-17e0d83e5f45",
    "ad44499d-73f7-4b95-b9cb-140c5c72f97e",
    "d77c592d-b138-4c5d-88a1-6dba7915d3d3",
    "82e33918-8f83-4440-9857-5b0d6298f241",
  ].includes(eventId);
};

export const isChilliPeppersFlexiMembershipHack = (
  organizationId: string
): boolean => {
  return [
    "9cf6fc7b-498d-44f2-b3b6-5ad7bdeb6cdb", // Chili Peppers
    "16602908-e0c4-4942-b541-0490dae79f53", // Staging
  ].includes(organizationId);
};
